module.exports = __webpack_public_path__ + "static/img/kiwiLoadingLogo.ee10be5a.png";